module.exports = __webpack_public_path__ + "img/man-with-shares.e0aa3a62.png";